(function () {
    'use strict';

    angular.module('mgpCorregedoriaApp').config(Config);

    function Config($translateProvider, $urlRouterProvider, $stateProvider, configuration, $qProvider, blockUIConfig) {

        $stateProvider
          .state('about', {
                url: "/about",
                templateUrl: "views/about.html"
            })
        ;

        $urlRouterProvider.otherwise("/");

        $translateProvider.useStaticFilesLoader({prefix: configuration.baseURL ,suffix: '.json'});
        $translateProvider.preferredLanguage(configuration.preferredLanguage);
        $translateProvider.useSanitizeValueStrategy('sceParameters');
        $qProvider.errorOnUnhandledRejections(false);

        blockUIConfig.delay = 100;
        blockUIConfig.autoBlock = false;

    }
})();
